import React from 'react'
import {FieldGoalListEditableProps} from "../../../render/goal-list/goal-list-editable"
import FieldString_RenderEditableInlineInput from "../../string/render/inline-editable/input-editable-inline"

const debug = false
// const debug = "FieldNumber_GoalListEditable"

export default function FieldNumber_GoalListEditable(props: FieldGoalListEditableProps) {
    const classes = Classes("ui5-txt-less-important-small", props.className)

    const value = props.model[props.field.fieldId]

    return <FieldString_RenderEditableInlineInput {...props} className={classes} value={value} onChange={props.onChange}/>
}
